export const timeout = (callback: () => void, time: number): void => {
  setTimeout(() => {
    callback();
  }, time * 1000);
};

export const saveDataToLocalStorage = (key: string, data: any): void => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getParsedLocalStorageItem = <T = any>(key: string): T | null => {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : null;
};
